import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { Link } from 'components/Link';
import { Text } from 'components/Text';
import { cx } from 'utility';
import * as styles from './SubHeader.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: '',
    navLinks: [],
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['header'],
    );

    return classes || undefined;
}

function SubHeader({
    className,
    navCtaEmoji,
    navCtaText,
    navCtaUrl,
    navLinks,
    navLinkTitle,
}) {
    const classes = getClasses({ className });

    return (
        <header className={classes}>
            <Grid>
                <div className={styles['container']}>
                    <nav className={styles['nav']}>
                        <div className={styles['navPrimary']}>
                            {navLinkTitle && (
                                <Text as="strong" className={styles['navListTitle']} size={1}>
                                    <Text as="span" emphasis="medium" size={1}>{navLinkTitle}</Text>
                                    <Text as="span" emphasis="high" size={1}>👉</Text>
                                </Text>
                            )}
                            {navLinks.length > 0 && (
                                <ul className={styles['navList']}>
                                    {navLinks.map(({ nav_link_text, nav_link_url }, index) => {
                                        const linkText = nav_link_text?.text;
                                        const linkUrl = nav_link_url;

                                        return (
                                            <li className={styles['navItem']} key={`sub-header-nav-item-${index}`}>
                                                <Link className={styles['navLink']} size={1} to={linkUrl}>{linkText}</Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                        {navCtaText && (
                            <div className={styles['navSecondary']}>
                                <Text as="span" emphasis="high" size={1}>{navCtaEmoji}</Text>
                                <Link className={styles['navCta']} size={1} to={navCtaUrl}>{navCtaText}</Link>
                            </div>
                        )}
                    </nav>
                </div>
            </Grid>
        </header>
    );
}

SubHeader.propTypes = propTypes;
SubHeader.defaultProps = defaultProps;

export { SubHeader };
